import { Button, ButtonKindValue } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import DownloadIcon from 'pages/certificates/assets/download-icon.svg'
import { TrackClick } from 'pages/certificates/tracking'

export const DownloadSyllabusButton = ({
  onClick,
  style,
  kind = 'secondary',
}: {
  onClick: () => void
  style?: React.CSSProperties
  kind?: ButtonKindValue
}) => {
  const { t } = useTranslation('@mc/certificates')

  return (
    <TrackClick event='certificateLandingClick' action='download syllabus'>
      <Button
        kind={kind}
        onClick={onClick}
        className='d-flex align-items-center c-gap-2'
        style={style}
      >
        {t('downloadSyllabus.title')}
        <DownloadIcon />
      </Button>
    </TrackClick>
  )
}
